import { render, staticRenderFns } from "./supplier_types.vue?vue&type=template&id=c2a114c6&scoped=true&"
import script from "./supplier_types.vue?vue&type=script&lang=js&"
export * from "./supplier_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a114c6",
  null
  
)

export default component.exports